export const ordersKeys = {
  all: ['orders'] as const,
  lists: () => [...ordersKeys.all, 'list'] as const,
  list: (params: Record<string, any> = {}) =>
    [...ordersKeys.lists(), params] as const,

  details: () => [...ordersKeys.all, 'detail'] as const,
  detail: (id: number) => [...ordersKeys.details(), id] as const,

  basket: (basketId: number) =>
    [...ordersKeys.all, 'basket', basketId] as const,

  committedBasket: (basketId: number) =>
    [...ordersKeys.all, 'committedBasket', basketId] as const,
};
